import { AppBar, Container, Stack, Toolbar } from "@mui/material";
import { useLayoutEffect, useMemo } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import OnboardingNavBar from "src/components/NavBars/OnboardingNavBar/OnboardingNavBar";
import PromoBanner from "src/components/PromoBanner";
import { MatchParam } from "src/constants/matches";

interface Props {
  showLanguageSelect?: boolean;
}
const RegistrationLayout = ({ showLanguageSelect = true }: Props) => {
  const { pathname } = useLocation();
  const { questionId } = useParams<MatchParam<"QUESTION_ID">>();

  const showCountdown = useMemo(() => questionId === "6SJGE6Tr", [questionId]);
  const isPaymentConfirmation = useMemo(
    () => questionId === "1XiyU8a4",
    [questionId]
  );

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <Stack pt={1.5}>
      <AppBar
        position="fixed"
        sx={{
          width: `100%`,
          boxShadow: "none",
          backgroundColor: "#ffffff",
          color: "#000000",
        }}
      >
        <Stack spacing={1}>
          <OnboardingNavBar hasNoLanguageSelect={!showLanguageSelect} />
          {isPaymentConfirmation ? null : (
            <PromoBanner showCountdown={showCountdown} />
          )}
        </Stack>
      </AppBar>
      <Toolbar />
      <Toolbar />
      <Container
        disableGutters
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          p: 2,
          overflowY: "auto",
          mt: 1,
        }}
      >
        <Outlet />
      </Container>
    </Stack>
  );
};

export default RegistrationLayout;
